
import {DecryptString} from '../../../static/js/xintong/AESUtils.js'
import {hideXWMenu,isWeiXin} from '../../api/showWXmenu.js';
import XHeader from 'vux/src/components/x-header/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {fetch,promptMessage} from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
export default {
data(){
return {
shopList:[],
buttons2: []
}
},
components: {
XHeader,FormPreview,Divider
},
methods:{
detailDel(index){
fetch('post',urlConfig.jifenExchangeDel +'?cardId='+ this.shopList[index].CARDID).then(response => {
this.$vux.toast.text('标记成功！');
this.getmessage();
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
this.$vux.toast.text('标记失败，请重试');
this.$store.commit('updateLoadingStatus',{isLoading:false});
})
},
getmessage(){
let _this = this;

fetch('post',urlConfig.jifenExchangeDetail +'?sfzh='+ JSON.parse(DecryptString(this.$route.query.sign)).sfzh).then(response => {
console.log(response,333)
this.shopList = [];
for(let i =0;i<response.length;i++){
this.shopList.push({list:[]});
for(let j in response[i]){

if(j == 'GOODSNAME'){
this.shopList[i].GOODSNAME = response[i].GOODSNAME;
}else if(j == 'GOODSNUM'){
this.obj = {};
this.obj.label = '数量'
this.obj.value = response[i].GOODSNUM;
this.shopList[i].list.push(this.obj);
}else if(j == 'BUYDATE'){
this.obj = {};
this.obj.label = '兑换日期';
this.obj.value = response[i].BUYDATE;
this.shopList[i].list.push(this.obj);
}else if(j == 'CARDNO'){
this.obj = {};
this.obj.label = '卡号'
this.obj.value = response[i].CARDNO;
this.shopList[i].list.push(this.obj);
}else if(j == 'CARDPWD'){

if(response[i].CARDPWD.substr(0,5) =='https'){
this.shopList[i].bottonclick =[{
style: 'primary',
text: '去使用',
onButtonClick: (name) => {
console.log(name,45,response[name].CARDPWD)
window.location.href= response[name].CARDPWD;
},
}
]
}else{
this.shopList[i].bottonclick =[];
this.obj = {};
this.obj.label = '密码'
this.obj.value = response[i].CARDPWD;
this.shopList[i].list.push(this.obj);
}

}else if(j == 'VALIDITY'){
this.obj = {};
this.obj.label = '截止有效期'
this.obj.value = response[i].VALIDITY;
this.shopList[i].list.push(this.obj);
}else if(j == 'STATUS'){
this.obj = {};
if(response[i][j] == '2'){
if((typeof (this.shopList[i].bottonclick)).toUpperCase()=='UNDEFINED'){
this.shopList[i]['bottonclick'] =[{
style: 'primary',
text: '标记为已使用',
onButtonClick: (index) => {
_this.detailDel(index);
},
}];
}else{
this.shopList[i]['bottonclick'].push({
style: 'primary',
text: '标记为已使用',
onButtonClick: (index) => {
_this.detailDel(index);
},
})
}
}else if(response[i][j] == '3'){
this.obj.label = '状态';
this.obj.value = '已使用';
}
this.shopList[i].list.push(this.obj);
}

}

this.shopList[i]['CARDID'] = response[i].CARDID;
}
/*console.log(this.shopList,45)*/
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
})
}
},
mounted(){
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.getmessage();
isWeiXin();
}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integralMallExchangeDetails.vue